import { HttpInterceptorFn } from '@angular/common/http';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  // Use nullish coalescing to provide a default empty string
  const sessionData = sessionStorage.getItem('currentUser');
  const localData = localStorage.getItem('currentUser');
  const userData = sessionData ?? localData ?? '{}'; // Provide a default empty object string
  
  const currentUser = JSON.parse(userData);
  if (currentUser && currentUser.token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${currentUser.token}`
      }
    });
    return next(cloned);
  }

  return next(req);
};
